"use strict";
/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationErrorMessage = exports.upgrade = exports.costManagementWidget = exports.common = exports.actions = exports.onLanguageChanged = exports.changeLanguage = exports.isInit = exports.onMissingKey = exports.i18nUtils = exports.onInit = exports.init = exports.i18n = exports.bundled = void 0;
// tslint:disable
var loom_i18n_1 = require("loom-i18n");
var en_1 = require("loom-i18n/dist/locale-data/en");
exports.bundled = {};
exports.bundled["en"] = {
    actions: {
        add: "Add",
        bake: "Bake",
        delete: "Delete",
        loading: "Loading...",
        selectStatus: "Select a status",
        warm: "Warm",
    },
    common: {
        cancel: "Cancel",
        confirm: "Confirm",
        error: "Error",
        errorLoadingData: "Error loading data",
        home: "Home",
        loading: "Loading...",
        success: "Success",
        yes: "Yes",
    },
    costManagementWidget: {
        title: "Cost Management",
        creditsTitle: "Credits",
        remainingBalance: "Remaining balance",
        trialDaysRemaining: "Trial days remaining",
        commitmentDaysRemaining: "Days remaining in billing cycle",
        currentBillingTitle: "Current billing cycle charges",
        consumptionPercentage: "{percentage} of your {total} credits used",
        daysElapsedInBilling: "{currentToStart} / {endToStart} days elapsed in billing cycle",
        daysElapsed: "Days elapsed",
        daysRemaining: "Days remaining",
        used: "Used",
        remaining: "Remaining",
        startingBalance: "Starting balance:",
        billingDetailsTitle: "Billing details",
        accountType: "Account type:",
        effectiveDate: "Effective date:",
        expirationDate: "Expiration date:",
        currentCycleStartDate: "Current billing cycle start date:",
        currentCycleEndDate: "Current billing cycle end date:",
        status: "Status:",
        ActionsTitle: "Actions",
        viewCostAnalysis: "View cost analysis",
        managePaymentMethod: "Upgrade and manage payment method",
        viewInvoices: "View invoices",
        upgradeToPayG: "Upgrade to Pay As You Go",
        requestSalesCall: "Request a sales call",
        upgradeNow: "Upgrade now",
        promoTitle: "You currently have Oracle Cloud Free Tier. Upgrade your account to access more services.",
        promoConsumedTitle: "You've used all your trial credits. Upgrade to access all of Oracle Clould Infrastructure services.",
        promoExpiredTitle: "Your trial credits have expired. Upgrade to access all of Oracle Cloud Infrastructure services.",
        noValue: "No value",
        ineligibleToUpgrade: "You can not upgrade because your tenancy is managed under Entreprise Agreement or You don't have a credit card on the file",
        upgradingTitle: "Your account upgrade is in progress.",
        tenantType: {
            promo: "Promotion",
            promoExpired: "Promotion Expired",
            payg: "Pay As You Go",
            monthly: "Monthly",
            anuual: "Annual",
        },
    },
    upgrade: {
        title: "Upgrade",
        description: "Upgrade your account to access all Oracle Cloud Infrastructure services.",
        error: {
            general: "You can not upgrad, please retry later",
            upgradeUnauthorizedError: "You do not have access to perform this operation. Please contact your cloud account administrator for additional access.",
            unavailableSub: "Your account provisioning is in progress. You will be able to access the feature after the provisioning is complete.",
            childTenancyFeatureUnavailable: "This feature is not supported on this page as it's a child account. Please contact your parent account Administrator or Sales Representative for additional assistance.",
        },
        payG: {
            title: "Pay As You Go",
            description: "For accounts where the monthly spend is up to a few thousand dollars. No minimum term and no prepayment required.",
            termsAndCondition: "I agree to the terms and conditions of the Cloud Services Agreement for Oracle America, Inc. (also available here) and this Order including Service Description for B88206 - Oracle PaaS and IaaS Universal Credits.",
            submit: "Submit request",
            upgardeStarted: "Your account upgrade is in progress. You will receive a confirmation email upon completion.",
        },
        salesCall: {
            title: "Request a sales call",
            description: "Have question? Request a call with our sales team.",
            email: "Email",
            phoneNumber: "Phone Number",
            submit: "Request sales call",
        },
        FAQs: {
            title: "FAQs",
            query1: "What happens after I upgrade?",
            query2: "What happens to the Oracle Cloud credit if I upgrade before 30 days?",
            query3: "Do I have to pay after I upgrade?",
            query4: "What happens with my products if I do not upgrade?",
        },
    },
    validationErrorMessage: {
        emailAddress: "Invalid email address",
        phoneNumber: "Invalid phone number",
        inputRequired: "This is required",
        selectRequired: "Please choose an option",
        duplicatedName: "This name is already in use. Please use a different name.",
    },
};
exports.bundled["en"] = {
    actions: {
        add: "Add",
        bake: "Bake",
        delete: "Delete",
        loading: "Loading...",
        selectStatus: "Select a status",
        warm: "Warm",
    },
    common: {
        cancel: "Cancel",
        confirm: "Confirm",
        error: "Error",
        errorLoadingData: "Error loading data",
        home: "Home",
        loading: "Loading...",
        success: "Success",
        yes: "Yes",
    },
    costManagementWidget: {
        title: "Cost Management",
        creditsTitle: "Credits",
        remainingBalance: "Remaining balance",
        trialDaysRemaining: "Trial days remaining",
        commitmentDaysRemaining: "Days remaining in billing cycle",
        currentBillingTitle: "Current billing cycle charges",
        consumptionPercentage: "{percentage} of your {total} credits used",
        daysElapsedInBilling: "{currentToStart} / {endToStart} days elapsed in billing cycle",
        daysElapsed: "Days elapsed",
        daysRemaining: "Days remaining",
        used: "Used",
        remaining: "Remaining",
        startingBalance: "Starting balance:",
        billingDetailsTitle: "Billing details",
        accountType: "Account type:",
        effectiveDate: "Effective date:",
        expirationDate: "Expiration date:",
        currentCycleStartDate: "Current billing cycle start date:",
        currentCycleEndDate: "Current billing cycle end date:",
        status: "Status:",
        ActionsTitle: "Actions",
        viewCostAnalysis: "View cost analysis",
        managePaymentMethod: "Upgrade and manage payment method",
        viewInvoices: "View invoices",
        upgradeToPayG: "Upgrade to Pay As You Go",
        requestSalesCall: "Request a sales call",
        upgradeNow: "Upgrade now",
        promoTitle: "You currently have Oracle Cloud Free Tier. Upgrade your account to access more services.",
        promoConsumedTitle: "You've used all your trial credits. Upgrade to access all of Oracle Clould Infrastructure services.",
        promoExpiredTitle: "Your trial credits have expired. Upgrade to access all of Oracle Cloud Infrastructure services.",
        noValue: "No value",
        ineligibleToUpgrade: "You can not upgrade because your tenancy is managed under Entreprise Agreement or You don't have a credit card on the file",
        upgradingTitle: "Your account upgrade is in progress.",
        tenantType: {
            promo: "Promotion",
            promoExpired: "Promotion Expired",
            payg: "Pay As You Go",
            monthly: "Monthly",
            anuual: "Annual",
        },
    },
    upgrade: {
        title: "Upgrade",
        description: "Upgrade your account to access all Oracle Cloud Infrastructure services.",
        error: {
            general: "You can not upgrad, please retry later",
            upgradeUnauthorizedError: "You do not have access to perform this operation. Please contact your cloud account administrator for additional access.",
            unavailableSub: "Your account provisioning is in progress. You will be able to access the feature after the provisioning is complete.",
            childTenancyFeatureUnavailable: "This feature is not supported on this page as it's a child account. Please contact your parent account Administrator or Sales Representative for additional assistance.",
        },
        payG: {
            title: "Pay As You Go",
            description: "For accounts where the monthly spend is up to a few thousand dollars. No minimum term and no prepayment required.",
            termsAndCondition: "I agree to the terms and conditions of the Cloud Services Agreement for Oracle America, Inc. (also available here) and this Order including Service Description for B88206 - Oracle PaaS and IaaS Universal Credits.",
            submit: "Submit request",
            upgardeStarted: "Your account upgrade is in progress. You will receive a confirmation email upon completion.",
        },
        salesCall: {
            title: "Request a sales call",
            description: "Have question? Request a call with our sales team.",
            email: "Email",
            phoneNumber: "Phone Number",
            submit: "Request sales call",
        },
        FAQs: {
            title: "FAQs",
            query1: "What happens after I upgrade?",
            query2: "What happens to the Oracle Cloud credit if I upgrade before 30 days?",
            query3: "Do I have to pay after I upgrade?",
            query4: "What happens with my products if I do not upgrade?",
        },
    },
    validationErrorMessage: {
        emailAddress: "Invalid email address",
        phoneNumber: "Invalid phone number",
        inputRequired: "This is required",
        selectRequired: "Please choose an option",
        duplicatedName: "This name is already in use. Please use a different name.",
    },
};
exports.i18n = new loom_i18n_1.LoomI18n();
/**
 * Initialize the instance. If no {@code defaultLanguage} are provided, tries to automatically detect the language
 * @param defaultLanguage The language to use initially
 */
function init(defaultLanguage, localeOptions) {
    exports.i18n.initSync({
        defaultLanguage: defaultLanguage,
        resources: exports.bundled,
        localesData: {
            en: en_1.default,
        },
        defaultCurrency: localeOptions && localeOptions.defaultCurrency,
        defaultTimezone: localeOptions && localeOptions.defaultTimezone,
    });
}
exports.init = init;
/**
 * Add a notification callback on initialization time. Please set this before you call @method init
 * @param callback
 */
function onInit(callback) {
    exports.i18n.onInit(callback);
}
exports.onInit = onInit;
/**
 * Helper functions for i18n.
 */
exports.i18nUtils = {
    /**
     * Function to format currency.
     * @param value
     * @deprecated We will be removing "Code" and only have optional "Options" object where you can specify the currency
     * @param codeOrOptions Currency code to use, defaults to USD. Use getCurrencyCode to map string to Currency.Code enum
     * or Options object to set currencyCode(defaults to USD), displayFormat(Defaults to Symbol) and precision
     * @deprecated We will be removing "displayFormat" in the future. You can set this in the Options object
     * @param displayFormat Display as symbol or name. Eg. $5.00 or 5 US Dollars, Defaults to Symbol.
     * This is ignored if "Options" object is provided
     */
    formatCurrency: function formatCurrency(value, codeOrOptions, displayFormat) {
        return exports.i18n.formatCurrency(value, codeOrOptions, displayFormat);
    },
    /**
     * Get Currency.Code enum from the specified string. If not found, returns the string value cast as enum.
     * @param code Currency code string to look up.
     */
    getCurrencyCode: function getCurrencyCode(code) {
        return loom_i18n_1.Currency.Code.code || code;
    },
};
/**
 * Add a notification callback on missing translation key. Useful for applications that may need to do
 * work once the translation key is missing in translation files.
 * @param callback
 */
function onMissingKey(callback) {
    exports.i18n.onMissingKey(callback);
}
exports.onMissingKey = onMissingKey;
/**
 * Function to check if the instance is initialized.
 */
function isInit() {
    return exports.i18n.isInitialized;
}
exports.isInit = isInit;
/**
 * Change the language of the current instance.
 * @param language New language to use. Can be either language code (e.g. "en"), or locale code (e.g. "en-US"))
 */
function changeLanguage(language) {
    return exports.i18n.changeLanguage(language);
}
exports.changeLanguage = changeLanguage;
/**
 * Add a notification callback on change of language. Useful for applications that may need
 * to do work once the language is changed (e.g. forceUpdate of the root component in react)
 * @param callback
 */
function onLanguageChanged(callback) {
    exports.i18n.onLanguageChanged(callback);
}
exports.onLanguageChanged = onLanguageChanged;
function shouldReturnKey(key, returnKey, props) {
    if (returnKey) {
        return key;
    }
    else {
        return exports.i18n.t(key, props);
    }
}
exports.actions = {
    add: function actions_add(returnKey) {
        return shouldReturnKey("actions.add", returnKey, {});
    },
    bake: function actions_bake(returnKey) {
        return shouldReturnKey("actions.bake", returnKey, {});
    },
    delete: function actions_delete(returnKey) {
        return shouldReturnKey("actions.delete", returnKey, {});
    },
    loading: function actions_loading(returnKey) {
        return shouldReturnKey("actions.loading", returnKey, {});
    },
    selectStatus: function actions_selectStatus(returnKey) {
        return shouldReturnKey("actions.selectStatus", returnKey, {});
    },
    warm: function actions_warm(returnKey) {
        return shouldReturnKey("actions.warm", returnKey, {});
    },
};
exports.common = {
    cancel: function common_cancel(returnKey) {
        return shouldReturnKey("common.cancel", returnKey, {});
    },
    confirm: function common_confirm(returnKey) {
        return shouldReturnKey("common.confirm", returnKey, {});
    },
    error: function common_error(returnKey) {
        return shouldReturnKey("common.error", returnKey, {});
    },
    errorLoadingData: function common_errorLoadingData(returnKey) {
        return shouldReturnKey("common.errorLoadingData", returnKey, {});
    },
    home: function common_home(returnKey) {
        return shouldReturnKey("common.home", returnKey, {});
    },
    loading: function common_loading(returnKey) {
        return shouldReturnKey("common.loading", returnKey, {});
    },
    success: function common_success(returnKey) {
        return shouldReturnKey("common.success", returnKey, {});
    },
    yes: function common_yes(returnKey) {
        return shouldReturnKey("common.yes", returnKey, {});
    },
};
exports.costManagementWidget = {
    title: function costManagementWidget_title(returnKey) {
        return shouldReturnKey("costManagementWidget.title", returnKey, {});
    },
    creditsTitle: function costManagementWidget_creditsTitle(returnKey) {
        return shouldReturnKey("costManagementWidget.creditsTitle", returnKey, {});
    },
    remainingBalance: function costManagementWidget_remainingBalance(returnKey) {
        return shouldReturnKey("costManagementWidget.remainingBalance", returnKey, {});
    },
    trialDaysRemaining: function costManagementWidget_trialDaysRemaining(returnKey) {
        return shouldReturnKey("costManagementWidget.trialDaysRemaining", returnKey, {});
    },
    commitmentDaysRemaining: function costManagementWidget_commitmentDaysRemaining(returnKey) {
        return shouldReturnKey("costManagementWidget.commitmentDaysRemaining", returnKey, {});
    },
    currentBillingTitle: function costManagementWidget_currentBillingTitle(returnKey) {
        return shouldReturnKey("costManagementWidget.currentBillingTitle", returnKey, {});
    },
    consumptionPercentage: function costManagementWidget_consumptionPercentage(percentage, total, returnKey) {
        return shouldReturnKey("costManagementWidget.consumptionPercentage", returnKey, { percentage: percentage, total: total });
    },
    daysElapsedInBilling: function costManagementWidget_daysElapsedInBilling(currentToStart, endToStart, returnKey) {
        return shouldReturnKey("costManagementWidget.daysElapsedInBilling", returnKey, { currentToStart: currentToStart, endToStart: endToStart });
    },
    daysElapsed: function costManagementWidget_daysElapsed(returnKey) {
        return shouldReturnKey("costManagementWidget.daysElapsed", returnKey, {});
    },
    daysRemaining: function costManagementWidget_daysRemaining(returnKey) {
        return shouldReturnKey("costManagementWidget.daysRemaining", returnKey, {});
    },
    used: function costManagementWidget_used(returnKey) {
        return shouldReturnKey("costManagementWidget.used", returnKey, {});
    },
    remaining: function costManagementWidget_remaining(returnKey) {
        return shouldReturnKey("costManagementWidget.remaining", returnKey, {});
    },
    startingBalance: function costManagementWidget_startingBalance(returnKey) {
        return shouldReturnKey("costManagementWidget.startingBalance", returnKey, {});
    },
    billingDetailsTitle: function costManagementWidget_billingDetailsTitle(returnKey) {
        return shouldReturnKey("costManagementWidget.billingDetailsTitle", returnKey, {});
    },
    accountType: function costManagementWidget_accountType(returnKey) {
        return shouldReturnKey("costManagementWidget.accountType", returnKey, {});
    },
    effectiveDate: function costManagementWidget_effectiveDate(returnKey) {
        return shouldReturnKey("costManagementWidget.effectiveDate", returnKey, {});
    },
    expirationDate: function costManagementWidget_expirationDate(returnKey) {
        return shouldReturnKey("costManagementWidget.expirationDate", returnKey, {});
    },
    currentCycleStartDate: function costManagementWidget_currentCycleStartDate(returnKey) {
        return shouldReturnKey("costManagementWidget.currentCycleStartDate", returnKey, {});
    },
    currentCycleEndDate: function costManagementWidget_currentCycleEndDate(returnKey) {
        return shouldReturnKey("costManagementWidget.currentCycleEndDate", returnKey, {});
    },
    status: function costManagementWidget_status(returnKey) {
        return shouldReturnKey("costManagementWidget.status", returnKey, {});
    },
    ActionsTitle: function costManagementWidget_ActionsTitle(returnKey) {
        return shouldReturnKey("costManagementWidget.ActionsTitle", returnKey, {});
    },
    viewCostAnalysis: function costManagementWidget_viewCostAnalysis(returnKey) {
        return shouldReturnKey("costManagementWidget.viewCostAnalysis", returnKey, {});
    },
    managePaymentMethod: function costManagementWidget_managePaymentMethod(returnKey) {
        return shouldReturnKey("costManagementWidget.managePaymentMethod", returnKey, {});
    },
    viewInvoices: function costManagementWidget_viewInvoices(returnKey) {
        return shouldReturnKey("costManagementWidget.viewInvoices", returnKey, {});
    },
    upgradeToPayG: function costManagementWidget_upgradeToPayG(returnKey) {
        return shouldReturnKey("costManagementWidget.upgradeToPayG", returnKey, {});
    },
    requestSalesCall: function costManagementWidget_requestSalesCall(returnKey) {
        return shouldReturnKey("costManagementWidget.requestSalesCall", returnKey, {});
    },
    upgradeNow: function costManagementWidget_upgradeNow(returnKey) {
        return shouldReturnKey("costManagementWidget.upgradeNow", returnKey, {});
    },
    promoTitle: function costManagementWidget_promoTitle(returnKey) {
        return shouldReturnKey("costManagementWidget.promoTitle", returnKey, {});
    },
    promoConsumedTitle: function costManagementWidget_promoConsumedTitle(returnKey) {
        return shouldReturnKey("costManagementWidget.promoConsumedTitle", returnKey, {});
    },
    promoExpiredTitle: function costManagementWidget_promoExpiredTitle(returnKey) {
        return shouldReturnKey("costManagementWidget.promoExpiredTitle", returnKey, {});
    },
    noValue: function costManagementWidget_noValue(returnKey) {
        return shouldReturnKey("costManagementWidget.noValue", returnKey, {});
    },
    ineligibleToUpgrade: function costManagementWidget_ineligibleToUpgrade(returnKey) {
        return shouldReturnKey("costManagementWidget.ineligibleToUpgrade", returnKey, {});
    },
    upgradingTitle: function costManagementWidget_upgradingTitle(returnKey) {
        return shouldReturnKey("costManagementWidget.upgradingTitle", returnKey, {});
    },
    tenantType: {
        promo: function costManagementWidget_tenantType_promo(returnKey) {
            return shouldReturnKey("costManagementWidget.tenantType.promo", returnKey, {});
        },
        promoExpired: function costManagementWidget_tenantType_promoExpired(returnKey) {
            return shouldReturnKey("costManagementWidget.tenantType.promoExpired", returnKey, {});
        },
        payg: function costManagementWidget_tenantType_payg(returnKey) {
            return shouldReturnKey("costManagementWidget.tenantType.payg", returnKey, {});
        },
        monthly: function costManagementWidget_tenantType_monthly(returnKey) {
            return shouldReturnKey("costManagementWidget.tenantType.monthly", returnKey, {});
        },
        anuual: function costManagementWidget_tenantType_anuual(returnKey) {
            return shouldReturnKey("costManagementWidget.tenantType.anuual", returnKey, {});
        },
    },
};
exports.upgrade = {
    title: function upgrade_title(returnKey) {
        return shouldReturnKey("upgrade.title", returnKey, {});
    },
    description: function upgrade_description(returnKey) {
        return shouldReturnKey("upgrade.description", returnKey, {});
    },
    error: {
        general: function upgrade_error_general(returnKey) {
            return shouldReturnKey("upgrade.error.general", returnKey, {});
        },
        upgradeUnauthorizedError: function upgrade_error_upgradeUnauthorizedError(returnKey) {
            return shouldReturnKey("upgrade.error.upgradeUnauthorizedError", returnKey, {});
        },
        unavailableSub: function upgrade_error_unavailableSub(returnKey) {
            return shouldReturnKey("upgrade.error.unavailableSub", returnKey, {});
        },
        childTenancyFeatureUnavailable: function upgrade_error_childTenancyFeatureUnavailable(returnKey) {
            return shouldReturnKey("upgrade.error.childTenancyFeatureUnavailable", returnKey, {});
        },
    },
    payG: {
        title: function upgrade_payG_title(returnKey) {
            return shouldReturnKey("upgrade.payG.title", returnKey, {});
        },
        description: function upgrade_payG_description(returnKey) {
            return shouldReturnKey("upgrade.payG.description", returnKey, {});
        },
        termsAndCondition: function upgrade_payG_termsAndCondition(returnKey) {
            return shouldReturnKey("upgrade.payG.termsAndCondition", returnKey, {});
        },
        submit: function upgrade_payG_submit(returnKey) {
            return shouldReturnKey("upgrade.payG.submit", returnKey, {});
        },
        upgardeStarted: function upgrade_payG_upgardeStarted(returnKey) {
            return shouldReturnKey("upgrade.payG.upgardeStarted", returnKey, {});
        },
    },
    salesCall: {
        title: function upgrade_salesCall_title(returnKey) {
            return shouldReturnKey("upgrade.salesCall.title", returnKey, {});
        },
        description: function upgrade_salesCall_description(returnKey) {
            return shouldReturnKey("upgrade.salesCall.description", returnKey, {});
        },
        email: function upgrade_salesCall_email(returnKey) {
            return shouldReturnKey("upgrade.salesCall.email", returnKey, {});
        },
        phoneNumber: function upgrade_salesCall_phoneNumber(returnKey) {
            return shouldReturnKey("upgrade.salesCall.phoneNumber", returnKey, {});
        },
        submit: function upgrade_salesCall_submit(returnKey) {
            return shouldReturnKey("upgrade.salesCall.submit", returnKey, {});
        },
    },
    FAQs: {
        title: function upgrade_FAQs_title(returnKey) {
            return shouldReturnKey("upgrade.FAQs.title", returnKey, {});
        },
        query1: function upgrade_FAQs_query1(returnKey) {
            return shouldReturnKey("upgrade.FAQs.query1", returnKey, {});
        },
        query2: function upgrade_FAQs_query2(returnKey) {
            return shouldReturnKey("upgrade.FAQs.query2", returnKey, {});
        },
        query3: function upgrade_FAQs_query3(returnKey) {
            return shouldReturnKey("upgrade.FAQs.query3", returnKey, {});
        },
        query4: function upgrade_FAQs_query4(returnKey) {
            return shouldReturnKey("upgrade.FAQs.query4", returnKey, {});
        },
    },
};
exports.validationErrorMessage = {
    emailAddress: function validationErrorMessage_emailAddress(returnKey) {
        return shouldReturnKey("validationErrorMessage.emailAddress", returnKey, {});
    },
    phoneNumber: function validationErrorMessage_phoneNumber(returnKey) {
        return shouldReturnKey("validationErrorMessage.phoneNumber", returnKey, {});
    },
    inputRequired: function validationErrorMessage_inputRequired(returnKey) {
        return shouldReturnKey("validationErrorMessage.inputRequired", returnKey, {});
    },
    selectRequired: function validationErrorMessage_selectRequired(returnKey) {
        return shouldReturnKey("validationErrorMessage.selectRequired", returnKey, {});
    },
    duplicatedName: function validationErrorMessage_duplicatedName(returnKey) {
        return shouldReturnKey("validationErrorMessage.duplicatedName", returnKey, {});
    },
};
//# sourceMappingURL=Messages.js.map